module.exports = __webpack_public_path__ + "static/media/expImgWhite.a72bc9f7.svg";